export default __webpack_public_path__ + "static/developers-c2e666f41901ed736f85d41478790efd.jpg";